module.exports = __webpack_public_path__ + "img/td-4.c19d9cc0.jpg";